import type { FrontendManifest, ProjectData, ProjectManifest } from './types'

const root = './data'

async function readJson<T>(url: string): Promise<T> {
  const response = await fetch(url)
  if (!response.ok) throw new Error(`无法加载 ${url} (${response.status})`)
  return response.json() as Promise<T>
}

export async function loadManifest(): Promise<FrontendManifest> {
  return readJson<FrontendManifest>(`${root}/manifest.json`)
}

export async function loadProject(project: ProjectManifest): Promise<ProjectData> {
  const [provenance, viewerIndex, workbookSnapshot, checklistTemplate] = await Promise.all([
    readJson<ProjectData['provenance']>(project.provenance_url),
    readJson<ProjectData['viewerIndex']>(project.source_viewer_url),
    readJson<ProjectData['workbookSnapshot']>(project.workbook_url),
    readJson<ProjectData['checklistTemplate']>(project.checklist_template_url || './data/checklist-template-v1.json'),
  ])
  return { manifest: project, provenance, viewerIndex, workbookSnapshot, checklistTemplate }
}
